const LOGO_BITIBA_ABO = {
    alt: 'bitiba-Abo',
    file: 'autoship-logo-lockup-bitiba-DE',
    width: '110',
    widthMedium: '154',
};
const LOGO_BITIBA_SUBSCRIBE_AND_SAVE = {
    alt: 'Subscribe and Save',
    file: 'autoship-logo-lockup-bitiba-GB',
    width: '186',
    widthMedium: '261',
};
const LOGO_ZOOHIT_RELAX = {
    alt: 'zoohit Relax',
    file: 'autoship-logo-lockup-zoohit-SK',
    width: '92',
    widthMedium: '129',
};
const LOGO_ZOOPLUS_RELAX = {
    alt: 'zooplus Relax',
    file: 'autoship-logo-lockup-zooplus-IT',
    width: '99',
    widthMedium: '139',
};
const LOGO_ZOOPLUS_REPEAT = {
    alt: 'zooplus Repeat',
    file: 'autoship-logo-lockup-zooplus-GB',
    width: '110',
    widthMedium: '154',
};
const localeLogoMapping = {
    'bg-BG': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-BG',
            width: '99',
            widthMedium: '139',
        },
    },
    'cs-CZ': {
        zooplus: {
            alt: 'zoohit Autobalík',
            file: 'autoship-logo-lockup-zoohit-CZ',
            width: '119',
            widthMedium: '167',
        },
    },
    'da-DK': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-DK',
            width: '99',
            widthMedium: '139',
        },
    },
    'de-AT': {
        bitiba: {
            alt: 'bitiba-Abo',
            file: 'autoship-logo-lockup-bitiba-AT',
            width: '110',
            widthMedium: '154',
        },
        zooplus: {
            alt: 'zooplus Abo',
            file: 'autoship-logo-lockup-zooplus-AT',
            width: '87',
            widthMedium: '122',
        },
    },
    'de-CH': {
        bitiba: {
            alt: 'bitiba-Abo',
            file: 'autoship-logo-lockup-bitiba-de-CH',
            width: '110',
            widthMedium: '154',
        },
        zooplus: {
            alt: 'zooplus Abo',
            file: 'autoship-logo-lockup-zooplus-de-CH',
            width: '87',
            widthMedium: '122',
        },
    },
    'de-DE': {
        bitiba: {
            alt: 'bitiba-Abo',
            file: 'autoship-logo-lockup-bitiba-DE',
            width: '110',
            widthMedium: '154',
        },
        zooplus: {
            alt: 'zooplus Abo',
            file: 'autoship-logo-lockup-zooplus-DE',
            width: '87',
            widthMedium: '122',
        },
    },
    'el-GR': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-GR',
            width: '99',
            widthMedium: '139',
        },
    },
    en: {
        zooplus: LOGO_ZOOPLUS_REPEAT,
    },
    'en-GB': {
        bitiba: LOGO_BITIBA_SUBSCRIBE_AND_SAVE,
        zooplus: LOGO_ZOOPLUS_REPEAT,
    },
    'en-IE': {
        zooplus: LOGO_ZOOPLUS_REPEAT,
    },
    'es-ES': {
        bitiba: {
            alt: 'Compra Programada de bitiba',
            file: 'autoship-logo-lockup-bitiba-ES',
            width: '277',
            widthMedium: '388',
        },
        zooplus: {
            alt: 'zooplus Suscripción',
            file: 'autoship-logo-lockup-zooplus-ES',
            width: '141',
            widthMedium: '197',
        },
    },
    'fi-FI': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-FI',
            width: '99',
            widthMedium: '139',
        },
    },
    'fr-BE': {
        zooplus: {
            alt: 'zooplus Zen',
            file: 'autoship-logo-lockup-zooplus-BE',
            width: '86',
            widthMedium: '120',
        },
    },
    'fr-CH': {
        bitiba: {
            alt: 'bitiba-Abo',
            file: 'autoship-logo-lockup-bitiba-fr-CH',
            width: '110',
            widthMedium: '154',
        },
        zooplus: {
            alt: 'zooplus Abo',
            file: 'autoship-logo-lockup-zooplus-fr-CH',
            width: '87',
            widthMedium: '122',
        },
    },
    'fr-FR': {
        bitiba: {
            alt: 'Abonnement bitiba',
            file: 'autoship-logo-lockup-bitiba-FR',
            width: '186',
            widthMedium: '260',
        },
        zooplus: {
            alt: 'zooplus Zen',
            file: 'autoship-logo-lockup-zooplus-FR',
            width: '86',
            widthMedium: '120',
        },
    },
    'hr-HR': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-HR',
            width: '99',
            widthMedium: '139',
        },
    },
    'hu-HU': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-HU',
            width: '99',
            widthMedium: '139',
        },
    },
    'it-IT': {
        bitiba: {
            alt: 'Pianifica & Risparmia',
            file: 'autoship-logo-lockup-bitiba-IT',
            width: '207',
            widthMedium: '290',
        },
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-IT',
            width: '99',
            widthMedium: '139',
        },
    },
    'nb-NO': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-NO',
            width: '99',
            widthMedium: '139',
        },
    },
    'nl-NL': {
        bitiba: {
            alt: 'bitiba Abonnement',
            file: 'autoship-logo-lockup-bitiba-NL',
            width: '186',
            widthMedium: '260',
        },
        zooplus: {
            alt: 'zooplus Gemak',
            file: 'autoship-logo-lockup-zooplus-NL',
            width: '106',
            widthMedium: '149',
        },
    },
    'pl-PL': {
        zooplus: {
            alt: 'zooplus ABOnament',
            file: 'autoship-logo-lockup-zooplus-PL',
            width: '139',
            widthMedium: '195',
        },
    },
    'pt-PT': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-PT',
            width: '99',
            widthMedium: '139',
        },
    },
    'ro-RO': {
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-RO',
            width: '99',
            widthMedium: '139',
        },
    },
    'ru-RU': {
        zooplus: {
            alt: 'zoochic Relax',
            file: 'autoship-logo-lockup-zooplus-RU',
            width: '97',
            widthMedium: '136',
        },
    },
    'sl-SI': {
        zooplus: {
            alt: 'zoohit Relax',
            file: 'autoship-logo-lockup-zoohit-SI',
            width: '92',
            widthMedium: '129',
        },
    },
    'sk-SK': {
        zooplus: {
            alt: 'zoohit Relax',
            file: 'autoship-logo-lockup-zoohit-SK',
            width: '92',
            widthMedium: '129',
        },
    },
    'sv-SE': {
        bitiba: {
            alt: 'bitiba-prenumeration',
            file: 'autoship-logo-lockup-bitiba-SE',
            width: '206',
            widthMedium: '289',
        },
        zooplus: {
            alt: 'zooplus Relax',
            file: 'autoship-logo-lockup-zooplus-SE',
            width: '99',
            widthMedium: '139',
        },
    },
    // strange locales for new bitiba shops
    'hu-GB': {
        bitiba: LOGO_BITIBA_SUBSCRIBE_AND_SAVE,
        zooplus: LOGO_ZOOPLUS_RELAX,
    },
    'pt-GB': {
        bitiba: LOGO_BITIBA_SUBSCRIBE_AND_SAVE,
        zooplus: LOGO_ZOOPLUS_RELAX,
    },
    'ro-GB': {
        bitiba: LOGO_BITIBA_SUBSCRIBE_AND_SAVE,
        zooplus: LOGO_ZOOPLUS_RELAX,
    },
    'sk-GB': {
        bitiba: LOGO_BITIBA_SUBSCRIBE_AND_SAVE,
        zooplus: LOGO_ZOOHIT_RELAX,
    },
    'sl-GB': {
        bitiba: LOGO_BITIBA_SUBSCRIBE_AND_SAVE,
        zooplus: LOGO_ZOOHIT_RELAX,
    },
};

export { LOGO_BITIBA_ABO, LOGO_BITIBA_SUBSCRIBE_AND_SAVE, LOGO_ZOOPLUS_RELAX, localeLogoMapping };
//# sourceMappingURL=localeLogoMapping.js.map
